import React, { useEffect } from 'react';
import FlightCalculator from "../../common/components/offset/FlightCalculatorV2";
import FlightImpact from "../../common/components/offset/FlightImpact";
import Projects from "../../common/components/offset/Projects";
import ccLogo from "../../common/media/cc_logo_color.svg";
import ccLogoWhite from "../../common/media/cc_logo_white.svg";
import ccTrustPilot from "../../common/media/cc-trust-pilot.svg";
import {trackAdditionalPageView} from "../../common/util/ccAnalyticsV2";

const OffsetPage = ({ merchantCode, projects}) => {

    useEffect(() => {
        //trackAdditionalPageView('/offset',['aviation','customer'])
    }, []
    );

    return (
        <div>
            <div className="bg-secondary mobile-p-0 pb-5" style={{backgroundRepeat: "no-repeat", backgroundPosition: "left"}}>
                <div className="p-3 bg-white w-100 mb-4 center">
                    <img src={`https://res.cloudinary.com/carbonclick/image/upload/v1625183260/Enterprise/galapagos/logo_k5jgth.svg`} style={{ height: '90px' }} />
                </div>
                <div className="container mobile-p-0">
                    <div className="center shadow-lg">
                        <FlightCalculator merchantCode={merchantCode} />
                    </div>
                </div>
            </div>

            <div className="bg-primary img-cover pattern-3 py-4 color-white mb-3">
                <div className="container impact-color-white">
                    <FlightImpact merchantCode={merchantCode} />
                </div>
            </div>

            {projects?.length > 0 && <Projects projects={projects} />}
           
            <div className="center py-5">
                <div className="pb-3"><img width={200} src={ccLogo}></img></div>
                <a target="_blank" href="https://nz.trustpilot.com/review/www.carbonclick.com">
                    <div>
                        <img width={200} src={ccTrustPilot}></img>
                        <p className="color-black font-bold">On Trustpilot</p>
                    </div>
                </a>
            </div>

            <div className="bg-primary p-3 text-right">
                <div className="d-flex w-fit color-white right">
                    <h5 className="mr-2 font-bold mt-1 mb-0">Powered By</h5>
                    <div>
                        <a target="_blank" href="https://www.carbonclick.com/"><img style={{ height: 30 }} src={ccLogoWhite} /></a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OffsetPage;